module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 6.48c9f6c6.png";